<template>
    <div>
        <div class="mt-[16px] rounded-[4px] border-[1.5px] border-solid border-[#DBDCE0]">
            <div class="w-full bg-[#fbfbfb] py-[13px] px-[24px] border border-[#DBDCE0]">
                <h2 class="font-bold text-[12px] leading-[18px] text-[#353535]">
                    Assigned Distributor Managers
                </h2>
            </div>
        </div>
        <div v-if="loading">
            <div class="text-center w-full">
                <div class="text-center" style="padding-top: 100px; padding-bottom: 50px">
                    <span class="fa-solid fa-spinner fa-spin text-[#2463EB]" style="font-size: 8rem"></span>
                    <h3 class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                        style="padding-bottom: 100px">
                        Please wait while we loading the User's Lists
                    </h3>
                </div>
            </div>
        </div>
        <div v-for="(i, index) in salesTeam.salesTeamMapping" :key="index" v-else
            class="w-full bg-white py-[13px] px-[24px] border border-[#DBDCE0] flex items-center gap-[48px]">
            <h2 class="font-medium text-[14px] leading-[17px] max-w-[300px] w-full text-[#353535]">
                {{ i.staffName }}
            </h2>
            <!-- <span class="text-[#DC2828] font-normal text-[14px] leading-[20px] cursor-pointer">View Distributors</span> -->
        </div>
        <div v-if="!salesTeam.salesTeamMapping && !loading"
            class="w-full bg-white py-[13px] px-[24px] border border-[#DBDCE0]">
            <h2 class="font-medium text-[14px] leading-[17px] max-w-max text-[#353535]">
                No Team is currently assigned to this Sales User
            </h2>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            salesTeam: [],
            loading: false,
        }
    },
    mounted() {
        this.getUserMappings();
    },
    computed: {
        user: function () {
            return this.$store.state.currentUser;
        },
    },
    methods: {
        async getUserMappings() {
            try {
                this.loading = true;
                var a = true;
                const res = await this.$http.get(
                    "/SalesUsers/getMappings/" + this.user.id
                );
                const data = await res.json();
                this.salesTeam = JSON.parse(JSON.stringify(data));
                this.loading = false;
            } catch (err) {
                console.log(err)
                this.loading = false;
            }
        },
    }
}
</script>